export default "__VITE_ASSET__CfEDnCWb__";